import { BaseQueryApi, FetchArgs, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

import { host as baseUrl } from 'constants/apiconfig'
import { getBusinessUserToken } from 'modules/arplaybook/helper/auth'
import routes from 'modules/router/constants'

export const BUSINESS_USER_TOKEN = 'b-u-t-n'
export const STUDENT_TOKEN = 's-t-u-t-n'

const createAuthBaseQuery = (tokenKey: string, loginRoute: string) => {
    const baseQuery = fetchBaseQuery({
        baseUrl,
        prepareHeaders: headers => {
            const token = getBusinessUserToken(tokenKey)
            if (token) {
                headers.set('Authorization', `Bearer ${token}`)
            }
            return headers
        },
    })

    return async (args: string | FetchArgs, api: BaseQueryApi, extraOptions: {}) => {
        const result = await baseQuery(args, api, extraOptions)

        const tokenErros = [
            'Missing Authorization Header',
            'invalid token',
            'invalid algorithm',
            'jwt expired',
            'jwt malformed',
        ]
        if (
            result.error &&
            result.error.status === 401 &&
            tokenErros.includes((result.error.data as { message: string }).message)
        ) {
            localStorage.removeItem(tokenKey)
            window.location.href = loginRoute
        }

        return result
    }
}

export const businessUserBaseQueryWithAuth = createAuthBaseQuery(
    BUSINESS_USER_TOKEN,
    routes.AR_PLAYBOOK_ADMIN_LOGIN,
)

export const studentBaseQueryWithAuth = createAuthBaseQuery(
    STUDENT_TOKEN,
    routes.AR_PLAYBOOK_UNAUTHORIZED,
)
